import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/images/icon_question.png'


const _hoisted_1 = { class: "pantry-detail-data-view" }
const _hoisted_2 = {
  key: 0,
  class: "pantry-detail-data-plate-error"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "pantry-detail-data-plate-error-text",
  innerHTML: '正常動作してません。家電詳細画面を確認下さい。'
}, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "pantry-detail-data-update-area"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-data-update-text" }, "情報更新日時：", -1)
const _hoisted_6 = { class: "pantry-detail-data-update-text" }
const _hoisted_7 = {
  key: 2,
  class: "pantry-detail-data-update-empty"
}
const _hoisted_8 = { class: "pantry-detail-data-view-title-summary-area" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-data-view-title-text" }, "基本情報", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-detail-data-view-title-icon-image",
  src: _imports_0
}, null, -1)
const _hoisted_11 = { class: "pantry-detail-data-item-list" }
const _hoisted_12 = { class: "pantry-detail-data-graph-area" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-data-graph-title" }, "経過グラフ", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-data-graph-message" }, " 直近7日分の数量の経過を表示しています。 ", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-data-view-show-setting-text" }, "詳細設定", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryDetailDataItem = _resolveComponent("PantryDetailDataItem")
  const _component_PantryDetailGraphView = _resolveComponent("PantryDetailGraphView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isShowPlateError())
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : (_ctx.isShowUpdateDate())
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.updateDate), 1)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_7)),
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode("div", {
        class: "pantry-detail-data-view-title-icon-view",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickQuestion(...args)))
      }, [
        _hoisted_10
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_PantryDetailDataItem, {
        itemType: _ctx.DETAIL_ITEM_TYPE.STOCK_QUANTITY,
        iconUrl: _ctx.getIcon(_ctx.DETAIL_ITEM_TYPE.STOCK_QUANTITY),
        itemName: _ctx.getName(_ctx.DETAIL_ITEM_TYPE.STOCK_QUANTITY),
        value: 0,
        stockQuantity: _ctx.stockQuantity,
        isShowArrow: true,
        onChangeValue: _ctx.onChangeValue
      }, null, 8, ["itemType", "iconUrl", "itemName", "stockQuantity", "onChangeValue"]),
      _createVNode(_component_PantryDetailDataItem, {
        itemType: _ctx.DETAIL_ITEM_TYPE.PURCHASE_DATE,
        iconUrl: _ctx.getIcon(_ctx.DETAIL_ITEM_TYPE.PURCHASE_DATE),
        itemName: _ctx.getName(_ctx.DETAIL_ITEM_TYPE.PURCHASE_DATE),
        value: _ctx.purchaseDate,
        isShowArrow: true,
        onChangeValue: _ctx.onChangeValue
      }, null, 8, ["itemType", "iconUrl", "itemName", "value", "onChangeValue"]),
      _withDirectives(_createVNode(_component_PantryDetailDataItem, {
        itemType: _ctx.DETAIL_ITEM_TYPE.EXPIRATION_DATE,
        iconUrl: _ctx.getIcon(_ctx.DETAIL_ITEM_TYPE.EXPIRATION_DATE),
        itemName: _ctx.getName(_ctx.DETAIL_ITEM_TYPE.EXPIRATION_DATE),
        value: _ctx.expirationDate,
        isShowArrow: true,
        onChangeValue: _ctx.onChangeValue
      }, null, 8, ["itemType", "iconUrl", "itemName", "value", "onChangeValue"]), [
        [_vShow, _ctx.isShowData]
      ]),
      _withDirectives(_createVNode(_component_PantryDetailDataItem, {
        itemType: _ctx.DETAIL_ITEM_TYPE.STORAGE,
        iconUrl: _ctx.getIcon(_ctx.DETAIL_ITEM_TYPE.STORAGE),
        itemName: _ctx.getName(_ctx.DETAIL_ITEM_TYPE.STORAGE),
        value: _ctx.storage,
        isShowArrow: _ctx.isShowArrow(),
        onChangeValue: _ctx.onChangeValue
      }, null, 8, ["itemType", "iconUrl", "itemName", "value", "isShowArrow", "onChangeValue"]), [
        [_vShow, _ctx.isShowData]
      ]),
      _withDirectives(_createVNode(_component_PantryDetailDataItem, {
        itemType: _ctx.DETAIL_ITEM_TYPE.NOTIFICATION,
        iconUrl: _ctx.getIcon(_ctx.DETAIL_ITEM_TYPE.NOTIFICATION),
        itemName: _ctx.getName(_ctx.DETAIL_ITEM_TYPE.NOTIFICATION),
        value: _ctx.notificationDate,
        expirationDate: _ctx.expirationDate,
        isShowArrow: true,
        onChangeValue: _ctx.onChangeValue
      }, null, 8, ["itemType", "iconUrl", "itemName", "value", "expirationDate", "onChangeValue"]), [
        [_vShow, _ctx.isShowData]
      ]),
      _withDirectives(_createVNode(_component_PantryDetailDataItem, {
        itemType: _ctx.DETAIL_ITEM_TYPE.STOCK_NOTIFICATION,
        iconUrl: _ctx.getIcon(_ctx.DETAIL_ITEM_TYPE.STOCK_NOTIFICATION),
        itemName: _ctx.getName(_ctx.DETAIL_ITEM_TYPE.STOCK_NOTIFICATION),
        value: 0,
        notificationStock: _ctx.notificationStock,
        plateData: _ctx.plateData,
        isShowArrow: true,
        onChangeValue: _ctx.onChangeValue
      }, null, 8, ["itemType", "iconUrl", "itemName", "notificationStock", "plateData", "onChangeValue"]), [
        [_vShow, _ctx.isShowStockNotification()]
      ]),
      _withDirectives(_createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_PantryDetailGraphView, _mergeProps(_ctx.plateData, {
          class: "pantry-detail-data-graph",
          weightData: _ctx.getGraphData()
        }), null, 16, ["weightData"]),
        _hoisted_14
      ], 512), [
        [_vShow, _ctx.isShowGraph()]
      ])
    ]),
    _createVNode("div", {
      class: "pantry-detail-data-view-show-setting",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickShowSetting(...args)))
    }, [
      _hoisted_15,
      _createVNode("img", {
        class: "pantry-detail-data-view-show-setting-image",
        src: _ctx.getSettingImage()
      }, null, 8, ["src"])
    ])
  ]))
}